/**
 * DI-5-3 — the ONE place the refusal is worded: a version with a client node
 * on a browser without File System Access read-write. Shown in place of the
 * drop zone, under the intent menu and as the tooltip of a marked choice —
 * always BEFORE the drop, never after the approve. The node titles come from
 * the served version (`fsa.ts:clientNeedsOf`); the words live in `fsa.ts`
 * (`UNSUPPORTED_BROWSER_MESSAGE`), beside the pure helpers that also print
 * them as a tooltip line.
 */
import type { ReactElement } from "react";
import { Alert, Box, Typography } from "@mui/material";
import {
  missingTitles,
  UNSUPPORTED_BROWSER_MESSAGE,
  type MissingRequirement,
} from "./fsa.js";

export interface UnsupportedBrowserNoticeProps {
  missing: readonly MissingRequirement[];
}

export function UnsupportedBrowserNotice({
  missing,
}: UnsupportedBrowserNoticeProps): ReactElement {
  const titles = missingTitles(missing);
  return (
    <Alert
      severity="warning"
      variant="outlined"
      data-testid="unsupported-browser-notice"
    >
      <Typography variant="body2" component="p">
        {UNSUPPORTED_BROWSER_MESSAGE}
      </Typography>
      {titles.length > 0 && (
        <Box
          component="ul"
          sx={{ m: 0, mt: 0.5, pl: 2.5 }}
          data-testid="unsupported-browser-nodes"
        >
          {titles.map((t) => (
            <Typography key={t} component="li" variant="body2">
              {t}
            </Typography>
          ))}
        </Box>
      )}
    </Alert>
  );
}
